import React from "react";
import { ResponsiveBar } from "@nivo/bar";
import { styled } from "@mui/system";

const RootStyle = styled("div")({
  height: "300px",
  width: "100%",
});

function MonthlyChart({ sales, type, totalColor }) {
  // console.log(sales);

  const data = [
    {
      month: "Jan",
      loss: sales?.jan?.loss || 0,
      Profit: sales?.jan?.profit || 0,
      [type]: sales?.jan?.total,
      color: "#bebebe",
    },
    {
      month: "Feb",
      [type]: sales?.feb?.total,
      Profit: sales?.feb?.profit || 0,
      loss: sales?.feb?.loss || 0,
      color: "#bebebe",
    },
    {
      month: "Mar",
      [type]: sales?.mar?.total,
      Profit: sales?.mar?.profit || 0,
      loss: sales?.mar?.loss || 0,
      color: "#bebebe",
    },
    {
      month: "Apr",
      [type]: sales?.apr?.total,
      Profit: sales?.apr?.profit || 0,
      loss: sales?.apr?.loss || 0,
      color: "#bebebe",
    },
    {
      month: "May",
      [type]: sales?.may?.total,
      Profit: sales?.may?.profit || 0,
      loss: sales?.may?.loss || 0,
      color: "#ebebbe",
    },
    {
      month: "Jun",
      [type]: sales?.jun?.total,
      Profit: sales?.jun?.profit || 0,
      loss: sales?.jun?.loss || 0,
      color: "#bebebe",
    },
    {
      month: "Jul",
      [type]: sales?.jul?.total,
      Profit: sales?.jul?.profit || 0,
      loss: sales?.jul?.loss || 0,
      color: "#bebebe",
    },
    {
      month: "Aug",
      [type]: sales?.aug?.total,
      Profit: sales?.aug?.profit || 0,
      loss: sales?.aug?.loss || 0,
      color: "#bebebe",
    },
    {
      month: "Sep",
      loss: sales?.sep?.loss || 0,
      Profit: sales?.sep?.profit || 0,
      [type]: sales?.sep?.total,
      color: "#bebebe",
    },
    {
      month: "Oct",
      [type]: sales?.oct?.total,
      Profit: sales?.oct?.profit || 0,
      loss: sales?.oct?.loss || 0,
      color: "#bebebe",
    },
    {
      month: "Nov",
      [type]: sales?.nov?.total,
      Profit: sales?.nov?.profit || 0,
      loss: sales?.nov?.loss || 0,
      color: "#bebebe",
    },
    {
      month: "Dec",
      [type]: sales?.dec?.total,
      Profit: sales?.dec?.profit || 0,
      loss: sales?.dec?.loss || 0,
      color: "#bebebe",
    },
  ];

  return (
    <RootStyle>
      <ResponsiveBar
        data={data}
        keys={[type, "Profit", "loss"]}
        indexBy="month"
        margin={{ top: 5, right: 60, bottom: 50, left: 60 }}
        padding={0.9}
        colors={[totalColor, "#4CAF50", "#e50000"]}
        defs={[
          {
            id: "dots",
            type: "patternDots",
            background: "inherit",
            color: "#38bcb2",
            size: 4,
            padding: 1,
            stagger: true,
          },
          {
            id: "lines",
            type: "patternLines",
            background: "inherit",
            color: "#eed312",
            rotation: -45,
            lineWidth: 6,
            spacing: 10,
          },
        ]}
        fill={[]}
        borderColor={{ from: "color", modifiers: [["darker", "1.4"]] }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: "",
          legendPosition: "middle",
          legendOffset: 32,
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: "",
          legendPosition: "middle",
          legendOffset: -40,
        }}
        enableGridY={false}
        labelSkipWidth={11}
        labelSkipHeight={12}
        labelTextColor={{ from: "color", modifiers: [["darker", 1.6]] }}
        legends={[
          {
            dataFrom: "keys",
            anchor: "bottom-right",
            direction: "column",
            justify: false,
            translateX: 80,
            translateY: -65,
            itemsSpacing: 2,
            itemWidth: 102,
            itemHeight: 20,
            itemDirection: "left-to-right",
            itemOpacity: 0.85,
            symbolSize: 20,
            effects: [
              {
                on: "hover",
                style: {
                  itemOpacity: 1,
                },
              },
            ],
          },
        ]}
        animate={true}
        motionStiffness={90}
        motionDamping={15}
      />
    </RootStyle>
  );
}

export default MonthlyChart;
